import React from 'react';
import ReactDOM from 'react-dom';
import { ReactComponent as Logo } from '../asset/logo/logo.svg';
import ProgressRing from './common/ProgressRing';
import './OAuthLoginOverlay.css';

// 최초 소셜 로그인 콜백 처리 동안 GNB 등 하위 화면이 먼저 보이지 않도록
// 전체 화면을 덮고 로고 + 프로그레스 링만 노출하는 오버레이
const OAuthLoginOverlay = () => {
  return ReactDOM.createPortal(
    <div className="oauth-login-overlay" role="status" aria-label="로그인 처리 중">
      <ProgressRing size={88} borderWidth={4}>
        <Logo className="oauth-login-overlay-logo" aria-hidden="true" />
      </ProgressRing>
    </div>,
    document.body
  );
};

export default OAuthLoginOverlay;
